import React from 'react';
import navigation from '../../utils/navigation';
import ContactBtn from '../button/ContactBtn';
import GitHubIcon from '../icons/GitHubIcon';
import LinkedInIcon from '../icons/LinkedInIcon';
import MailIcon from '../icons/MailIcon';

const Contacts = () => (
  <div className="flex flex-col gap-5 py-8" id="contact">
    <div className="flex flex-col gap-2">
      <h1 className="text-5xl">Contact</h1>
      <p className="text-accentGray">
        If you&apos;d like to chat about a project i&apos;ll leave you my social
        media so we can get in touch.
      </p>
    </div>
    <div className="flex flex-wrap gap-4 ">
      <a href={navigation.github.link}>
        <ContactBtn
          backgroundColor="bg-gradient-to-br from-pink-500 to-orange-400 group-hover:from-pink-500 group-hover:to-orange-400 
    focus:ring-4 focus:ring-pink-200 dark:focus:ring-pink-800"
        >
          <GitHubIcon classNames="h-10 w-10 fill-white" />
          <p>{navigation.github.name}</p>
        </ContactBtn>
      </a>
      <a href={navigation.linkedin.link}>
        <ContactBtn backgroundColor="bg-gradient-to-br from-green-400 to-blue-600 group-hover:from-green-400 group-hover:to-blue-600">
          <LinkedInIcon classNames="h-10 w-10 fill-white" />
          <p>{navigation.linkedin.name}</p>
        </ContactBtn>
      </a>
      <a href="mailto:bgm94@hotmail.com">
        <ContactBtn backgroundColor="bg-gradient-to-br from-teal-300 to-lime-300 group-hover:from-teal-300 group-hover:to-lime-300 dark:text-white dark:hover:text-gray-900">
          <MailIcon classNames="h-10 w-10 fill-current" />
          <p>Mail</p>
        </ContactBtn>
      </a>
    </div>
  </div>
);

export default Contacts;
